import React from "react";
import { useAuth } from "contexts/auth";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { TUserRole } from "configs/routes";

interface IPros {
  allowed: TUserRole[];
  hasFeedBackElement?: boolean;
  children: any;
}

export const Permission = (props: IPros) => {
  const { user } = useAuth();
  const { t } = useTranslation();

  const roleNames = user?.roles?.map((item) => item.name) || [];
  console.log("roleNames", roleNames, props.allowed);
  if (
    props.allowed.length === 0 ||
    roleNames.some((a) => props?.allowed?.indexOf(a) >= 0)
  ) {
    return <React.Fragment>{props.children}</React.Fragment>;
  } else {
    return (
      <Tooltip title={t("notAllowed")} placement="auto">
        <div className={"opacity-40 relative !cursor-default"}>
          <div
            className="absolute inset-0 z-10"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          />
          {props.children}
        </div>
      </Tooltip>
    );
  }

  // if (props.hasFeedBackElement) {
  //   // if (true) {
  //   return (
  //     <div className={`${design.main}`}>
  //       <i className={`fa-regular fa-hand ${design.danger}`}></i>
  //       <h1>{t("youDontHavePermission")}</h1>
  //       <p className={`${design.message}`}>
  //         {t("accessToThisResourceIsDenied")}
  //       </p>
  //     </div>
  //   );
  // }

  // return <React.Fragment />;
};
